import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between pa-4" }
const _hoisted_2 = { class: "d-flex items-center" }
const _hoisted_3 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_card_body = _resolveComponent("my-card-body")!
  const _component_my_card = _resolveComponent("my-card")!

  return (_openBlock(), _createBlock(_component_my_card, { class: "mt-4" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("i", { class: "iconfont iconreport-icon-shidu title-icon" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("humidity")) + " ", 1),
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "unit" }, "%", -1))
        ]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(Math.min(...$props.yAxis)) + "-" + _toDisplayString(Math.max(...$props.yAxis)), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_my_card_body, { class: "px-4" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref: $setup.setRef,
            style: {"height":"60vw","width":"100%"}
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}